for(const more of document.querySelectorAll('body.p-formation_continue .creneaux .more')) {

  const labelOn = more.getAttribute('data-label-on')
  const labelOff = more.getAttribute('data-label-off')

  more.addEventListener('click', (e) => {
    const label = document.querySelector('.more strong')
    const x = document.querySelector('.creneaux-more')
    if (x.style.display === "none") {
      x.style.display = "block"
      label.innerHTML = labelOn
    } else {
      x.style.display = "none"
      label.innerHTML = labelOff
    }
  })
}
